import { useEffect } from "react";
import { createRealtimeChannel } from "../services/realtime.js";
import { reconcile, reconcileLoaded } from "../commands/reconcile.js";
import { REALTIME_EVENT_TYPES } from "../lib/realtimeEvents.generated.js";

/**
 * A hint says only WHEN to read, never what changed — so every type does the same thing.
 * @param {{ qkey?: string } | null | undefined} d
 */
const onHint = (d) => {
  if (d && d.qkey) void reconcile([d.qkey]);
};

/**
 * On stream re-establishment the hook reconciles every loaded contract, because the channel
 * has no replay buffer and hints sent while the stream was down are lost. The channel itself
 * handles reconnect and visibility pause; the hook owns only its lifecycle.
 *
 * @param {{ enabled: boolean }} args `enabled` gates the connection on a signed-in session,
 *   because only authed users hold forecasts to receive events for.
 */
export function useRealtimeChannel({ enabled }) {
  useEffect(() => {
    if (!enabled) return undefined;
    const channel = createRealtimeChannel({
      handlers: Object.fromEntries(REALTIME_EVENT_TYPES.map((type) => [type, onHint])),
      onReopen: () => void reconcileLoaded(),
    });
    channel.start();
    return () => channel.stop();
  }, [enabled]);
}
